"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IObjectWithSeverity = exports.AggregateErrorWithSeverity = exports.ComponentInstanceValidationError = exports.ComponentModelValidationError = exports.ErrorWithInternal = void 0;
exports.serializeInnerError = serializeInnerError;
exports.deserializeInnerError = deserializeInnerError;
exports.isErrorWithSeverity = isErrorWithSeverity;
const zod_1 = require("zod");
const BoundaryLevel_1 = require("./BoundaryLevel");
function serializeInnerError(error) {
    if ('toJSON' in error && typeof error.toJSON === 'function') {
        return error.toJSON();
    }
    const result = {
        message: error.message,
        stack: error.stack,
        name: error.name,
    };
    if ('errors' in error && Array.isArray(error.errors)) {
        result.errors = error.errors.map((e) => (e instanceof Error ? serializeInnerError(e) : e));
    }
    return result;
}
function deserializeInnerError(serialized) {
    const message = typeof serialized.message === 'string' ? serialized.message : '';
    const name = typeof serialized.name === 'string' ? serialized.name : undefined;
    const stack = typeof serialized.stack === 'string' ? serialized.stack : undefined;
    const rawErrors = Array.isArray(serialized.errors) ? serialized.errors : undefined;
    const rehydratedErrors = rawErrors?.map((e) => e !== null && typeof e === 'object' ?
        deserializeInnerError(e)
        : new Error(typeof e === 'string' ? e : String(e)));
    const error = rehydratedErrors !== undefined ? new AggregateError(rehydratedErrors, message) : new Error(message);
    if (name !== undefined) {
        error.name = name;
        Object.defineProperty(error, 'name', { value: name });
    }
    if (stack !== undefined) {
        error.stack = stack;
        Object.defineProperty(error, 'stack', { value: stack });
    }
    if (serialized.innerError && typeof serialized.innerError === 'object') {
        error.innerError = deserializeInnerError(serialized.innerError);
    }
    return error;
}
class ErrorWithInternal extends Error {
    constructor(message, innerError) {
        super(message);
        this.innerError = innerError;
        Object.setPrototypeOf(this, ErrorWithInternal.prototype);
    }
    toJSON() {
        return {
            message: this.message,
            innerError: this.innerError ? serializeInnerError(this.innerError) : undefined,
            stack: this.stack,
            name: this.name,
        };
    }
}
exports.ErrorWithInternal = ErrorWithInternal;
class ComponentModelValidationError extends ErrorWithInternal {
    constructor(type, message, severity = BoundaryLevel_1.BoundaryLevel.Error, modelId, innerError) {
        super(`Failure during component model validation: ${message}`, innerError);
        this.type = type;
        this.severity = severity;
        this.modelId = modelId;
        Object.setPrototypeOf(this, ComponentModelValidationError.prototype);
    }
}
exports.ComponentModelValidationError = ComponentModelValidationError;
class ComponentInstanceValidationError extends ErrorWithInternal {
    constructor(type, message, severity = BoundaryLevel_1.BoundaryLevel.Error, innerError) {
        super(`Failure during component instance validation: ${message}`, innerError);
        this.type = type;
        this.severity = severity;
        Object.setPrototypeOf(this, ComponentInstanceValidationError.prototype);
    }
}
exports.ComponentInstanceValidationError = ComponentInstanceValidationError;
class AggregateErrorWithSeverity extends AggregateError {
    constructor(errors, message = 'One or more errors occurred', severityOverride, defaultSeverity = BoundaryLevel_1.BoundaryLevel.Error) {
        const severity = severityOverride ??
            (0, BoundaryLevel_1.getHighestBoundaryLevelFromArray)(Array.from(errors).map((err) => (isErrorWithSeverity(err) ? err.severity : undefined)), defaultSeverity);
        super(errors, message);
        Object.setPrototypeOf(this, AggregateErrorWithSeverity.prototype);
        this.severity = severity;
    }
}
exports.AggregateErrorWithSeverity = AggregateErrorWithSeverity;
exports.IObjectWithSeverity = zod_1.default.object({
    severity: BoundaryLevel_1.BoundaryLevelSchema,
});
function isErrorWithSeverity(error) {
    return (error !== null &&
        typeof error === 'object' &&
        'severity' in error &&
        BoundaryLevel_1.BoundaryLevelSchema.safeParse(error.severity).success);
}
//# sourceMappingURL=Errors.js.map